export default __webpack_public_path__ + "static/datacenter-architecture-c4fc960e23f5893df81a9d8ce380a912.webp";